<template>
   <div class="w-full">
        <ul class="flex flex-wrap gap-2">
            <li v-for="i in items" :key="i.id" >
                <div v-if="i.image_id" class="text-xxs">
                    <img :src="`/storage/images/${i.image?.filename}-320x120.${i.image?.extension}`" class="w-36" alt="x">
                    <ul>
                        <li>{{ i.image?.id }} - {{ i.image?.title }}</li>
                        <li>{{ i.image?.caption }}</li>
                        <li>{{ i.image?.description }}</li>
                    </ul>
                </div>
                <span v-else>
                    {{ i }}
                </span>
            </li>
        </ul>
   </div>
</template>

<script>
export default {
   name: "CarouselEditor",
   props: ['items'],
   computed: {},
   data() {
       return {

       }
   },
   mounted() {

   },
   methods: {

   }
}
</script>
